import { render, staticRenderFns } from "./zScrollLayout.vue?vue&type=template&id=58b35360&scoped=true&"
import script from "./zScrollLayout.vue?vue&type=script&lang=js&"
export * from "./zScrollLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b35360",
  null
  
)

export default component.exports